<template>
  <div class="bio">
    <p>{{user.bio}}</p>
  </div>
</template>

<script>
  export default {
    name: "UserBio",
    computed: {
      user() {
        return this.$store.getters.user;
      }
    }
  }
</script>

<style lang="scss" scoped>
  .bio {
    padding: 0 16px 16px 16px;
    font-size: 12px;
  }
</style>
